import {
  GetEvaluateFeatureRequest,
  GetEvaluateFeatureResponse,
} from '@amzn/awsconcierge-magic-movie-machine-type-script-client';
import ServiceProvider from 'services/ServiceProvider';

/**
 * @description Fetch the AB Test experiment from Eveidently API
 * @param props: GetEvaluateFeatureRequest :{entityId, projectId,featureId}
 */
export const fetchABTestExperiment = async (
  props: GetEvaluateFeatureRequest
): Promise<GetEvaluateFeatureResponse | null> => {
  try {
    /** Grab Howser Client Config, i.e., API EndPoint URL  */
    const client = ServiceProvider.getHowserService();

    // /** Generating request to be sent */
    const request: GetEvaluateFeatureRequest = {
      entityId: props.entityId || '',
      projectId: props.projectId,
      featureId: props.featureId,
    };
    const response: GetEvaluateFeatureResponse = await client.getEvaluateFeature(request);
    return response;
  } catch (error) {
    //** No client action required. Just loggin the error */
    // console.error(error);
    return null;
  }
};
